<script lang="ts" setup>
import ConfirmDialog from '@components/ui/modal/ConfirmDialog.vue'
import AdkButton from '@components/ui/AdkButton.vue'
import { useLocale } from '@composables/useLocale'
import { ConfirmDialogProps } from '@lib/models/modals'
import { createConfirmDialog } from 'vuejs-confirm-dialog'
import { useCartActions } from '@composables/useCartActions'
import { useGtm } from '@composables/useGtm'
import { LogoutType } from '@lib/models/gtm'

const { t } = useLocale()
const { cartUnits, sendReset } = useCartActions()
const { trackOnCloseModal, trackLogoutConfirmation } = useGtm()

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dialog = createConfirmDialog(ConfirmDialog as any)

const showSignoutModal = async () => {
  // only ask for confirmation when signing out would also lose cart products
  if (cartUnits.value) {
    const dialogProps: ConfirmDialogProps = {
      title: t('quieres_cerrar_tu_sesion'),
      description: t('si_lo_haces_se_vaciara_tu_carrito_y_tendras_que_empezar_de_nuevo'),
      primaryButton: t('Cerrar_sesion'),
      secondaryButton: t('Volver')
    }
    const { isCanceled } = await dialog.reveal(dialogProps)

    if (isCanceled) return trackOnCloseModal()
    trackLogoutConfirmation()
  }

  await sendReset(LogoutType.MANUAL)
}
</script>

<template>
  <AdkButton
    data-test="btn-signout"
    class="w-[calc(185*var(--vw))]"
    size="small"
    is-primary
    @press="showSignoutModal"
    >{{ t('Cerrar_sesion') }}</AdkButton
  >
</template>
